import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService_UnUsed } from '../_helpers/index'

@Component({
  selector: 'error',
  templateUrl: './error.component.html'
})




export class ErrorComponent {

  notification: string;
  showNotification: boolean;

  constructor(private router: Router, private notificationService: NotificationService_UnUsed) {


  }//end cosnt

  ngOnInit() {
    this.getAccessTokenStatus();
    this.notificationService
      .notification$
      .subscribe(message => {
        this.notification = message;
        this.showNotification = true;
      });
  }

  getAccessTokenStatus() {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken === undefined || accessToken === null || accessToken === '') {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate([`/login`]);
    }
  }

}//end
